// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5ce19594","453":"5702a144","455":"6f40ffdb","977":"b06b6880"}[chunkId] + ".chunk.js";
};